import React from 'react'
import RegisterContainer from './Container'
import GuestLayout from 'components/app/GuestLayout'

export default () => (
    <GuestLayout>
        <RegisterContainer />
    </GuestLayout>
)
